import { useState } from "react";
import { SlotBoard } from "./SlotBoard";
import { Stage } from "./Stage";
import { ActionBar } from "./ActionBar";
import { RoleSheet } from "./RoleSheet";
import { ChallengeBanner } from "./ChallengeBanner";
import { BoardBanner } from "./BoardBanner";
import { GameHeader } from "./GameHeader";
import { TransferBanner } from "./TransferBanner";
import { sfx } from "../../lib/sfx";

export const GameScreen = ({ game, challenge, boardCode }) => {
  const [selected, setSelected] = useState(null);

  const handleAssign = (roleKey) => {
    sfx.assign();
    game.assign(selected, roleKey);
    setSelected(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSpin = () => {
    sfx.spin();
    game.spin();
  };

  return (
    <>
      <main className="max-w-md mx-auto px-4 pt-6 pb-2 min-h-[100dvh] relative z-10" data-testid="game-screen">
        <TransferBanner />
        {challenge && <ChallengeBanner challenge={challenge} />}
        {boardCode && <BoardBanner />}
        <GameHeader filled={game.filledCount} />
        <p className="text-[11px] italic leading-snug text-[#506780] -mt-2 mb-5" data-testid="game-legend">
          Si narra che a raggiungere Laugh Tale non sia la ciurma più forte, ma quella meglio assortita. Scegli bene chi
          portare a bordo e in quale ruolo.
        </p>
        <Stage game={game} selectedId={selected?.id} onSelect={setSelected} />
        <SlotBoard assignments={game.assignments} lastFilled={game.lastFilled} />
      </main>
      <ActionBar phase={game.phase} rerollUsed={game.rerollUsed} onSpin={handleSpin} onReroll={game.reroll} />
      <RoleSheet character={selected} assignments={game.assignments} onAssign={handleAssign} onClose={() => setSelected(null)} />
    </>
  );
};
